import React from 'react';
import { useTranslation } from 'react-i18next';
import { arrayOf } from 'prop-types';
import { userType } from '../../types';
import './_styles_/MemberAssignedUsersTable.css';
import MemberAssignedUserRow from './MemberAssignedUserRow';

MemberAssignedUsersTable.propTypes = {
    users: arrayOf(userType).isRequired,
};

function MemberAssignedUsersTable(props) {
    const {
        users,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="member-detail-tab--users">
            <div className="field">
                <span className="field--key">{t('members.users.title')}</span>
                <div className="detail-list">
                    <div className="detail-list-row detail-list-header">
                        <div className="user-cell">{t('members.users.racf')}</div>
                        <div className="user-cell">{t('members.users.userCode')}</div>
                        <div className="user-cell">{t('members.users.name')}</div>
                        <div className="user-cell">{t('members.users.email')}</div>
                        <div className="user-cell">{t('members.users.suspended')}</div>
                        <div className="user-cell">{t('members.users.active')}</div>
                    </div>
                    {users.map((user) => <MemberAssignedUserRow key={user.racf} user={user} />)}
                </div>
            </div>
        </div>
    );
}

export default MemberAssignedUsersTable;
